import gql from 'graphql-tag';

// TODO: Replace params with actual docusign template & user (signer/cc email/name) data
const SEND_ENVELOPE = gql`
  mutation SendVOEnvelope($input: DocuSignTemplateInputs!, $VOId: ID) {
    sendVOEnvelope(input: $input, VOId: $VOId)
  }
`;

const SEND_ENVELOPE_V2 = gql`
  mutation SendVOEnvelopeV2($input: DocuSignTemplateInputsV2!, $VOId: ID) {
    sendVOEnvelopeV2(input: $input, VOId: $VOId)
  }
`;

const GET_DOCUSIGN_TEMPLATES = gql`
  query GetDocuSignTemplates($VOId: ID!) {
    options: getDocuSignTemplates(VOId: $VOId) {
      label: name
      value: templateId
      docusignAccountId
    }
  }
`;

export const docuSignApi = {
  sendEnvelopeV2: SEND_ENVELOPE_V2, // For accounts that work with DocuSign using ISVs
  getTemplates: GET_DOCUSIGN_TEMPLATES,
};
